<template>
  <v-container>
    <v-layout
      wrap
    >
      <v-flex xs12>
    <p class="error">{{ error }}</p>

    <p class="decode-result">Last result: <b>{{ result }}</b></p>

    Geschiedenis!
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}

</script>
